<template>
  <div class="team-container">
    <div class="team-title">咨询顾问团队</div>
    <div class="team-top">
      <Vue3Marquee :duration="30" :direction="'normal'" :pauseOnHover="true">
        <div class="image-wrapper">
          <div class="image-item-content" v-for="item in teamList" :key="item.id" @click="handleDetails(item.id)">
            <imgContainer :src="item.professionalPhoto" />
          </div>
        </div>
      </Vue3Marquee>
    </div>
    <div class="team-main">
      <div class="main-left" v-show="teamDetails.templateLocation==2">
        <imgContainer :src="teamDetails.professionalPhoto" />
      </div>
      <div class="main-right">
        <div class="main-right-name">
          <span class="individual-name" :title="teamDetails.name">{{ handleChara(teamDetails.name,10) }}</span>
          <span class="individual-position" :title="teamDetails.position">{{ handleChara(teamDetails.position,20) }}</span>
        </div>
        <div class="main-right-item">
          <div class="txt-common-title">主导方向：</div>
          <div class="txt-common-txt">{{ teamDetails.leadDirection }}</div>
        </div>
        <div class="main-right-item">
          <div class="txt-common-title">擅长行业：</div>
          <div class="txt-common-txt">{{ teamDetails.industry }}</div>
        </div>
        <div class="main-right-item">
          <div class="txt-common-title">标签关键词：</div>
          <div class="txt-common-txt">{{ teamDetails.tagKeyword }}</div>
        </div>
        <div class="main-right-item" v-if="teamDetails.personalProfile">
          <div class="txt-common-title">个人简介：</div>
          <div class="txt-common-txt">{{ teamDetails.personalProfile }}</div>
        </div>
        <div class="main-right-projectIntroduction" v-if="projectList.length>0">
          <div class="txt-common-title">项目介绍：</div>
          <div class="projectIntroduction-main">
            <Vue3Marquee v-if="projectList.length > 3" :duration="30" :direction="'normal'" :pauseOnHover="true">
              <div class="projectIntroduction-item" v-for="(item,index) in projectList" :key="index">
                <el-image class="list-image" :src="item" fit="cover" :hide-on-click-modal="true"
                          :preview-teleported="true" :preview-src-list="[item]"/>
              </div>
            </Vue3Marquee>
            <template v-else>
              <div class="projectIntroduction-item" v-for="(item,index) in projectList" :key="index">
                <el-image class="list-image" :src="item" fit="cover" :hide-on-click-modal="true"
                          :preview-teleported="true" :preview-src-list="[item]"/>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="main-img-right" v-show="teamDetails.templateLocation==1">
        <imgContainer :src="teamDetails.professionalPhoto" />
      </div>
    </div>
  </div>
</template>

<script setup>
import {getTeamDetails, getTeamList} from "@/api/apiHome";
import {ref, onMounted, onUnmounted} from "vue";
import {ElImage} from 'element-plus'
import {handleChara} from "@/utils/title";
import imgContainer from '@/components/imgContainer/index.vue'
import { Vue3Marquee } from 'vue3-marquee'

const teamList = ref([]);
const teamDetails = ref({})
const projectList = ref([])
const queryTeamList = async () => {
  const {code, data} = await getTeamList();
  if (code === 200) {
    teamList.value = data;
    if (teamList.value.length > 0) {
      handleDetails(teamList.value[0].id);
    }
  }
};
const handleDetails = async (id) => {
  const {code, data} = await getTeamDetails(id);
  if (code === 200) {
    teamDetails.value = data;
    if (data.projectIntroduction) {
      projectList.value = JSON.parse(data.projectIntroduction)
    }else {
      projectList.value =[]
    }
  }
}
onMounted(() => {
  queryTeamList();
});
</script>

<style scoped lang="scss">
.team-container{
  width: 1200px;
  margin: 70px auto;

}
.team-title{
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  margin-bottom: 40px;
  position: relative;
  text-align: center;
}
.team-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.team-top {
  width: 100%;
  overflow: hidden;
}

.image-wrapper {
  display: flex;
  cursor: pointer;
  user-select: none;
}

.image-item-content {
  flex: 0 0 auto;
  width: 202px;
  height: 269px;
  margin-right: 20px;
  transition: transform 0.3s ease;
}

.image-item-content:hover {
  transform: scale(1.05);
}

.team-main {
  display: flex;
  margin-top: 30px;
}

.main-left {
  width: 396px;
  height: 457px;
  margin-right: 30px;
}

.main-img-right{
  width: 396px;
  height: 457px;
  margin-left: 30px;
}
.main-right {
  flex: 1;
}

.main-right-name {
  height: 45px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 24px;
  color: #242424;
  padding-left: 14px;
  background: linear-gradient(90deg, #D3E6FF 0%, rgba(211, 230, 255, 0) 100%);

  .individual-position {
    margin-left: 38px;
  }
}

.main-right-item {
  display: flex;
  margin-top: 20px;

  .txt-common-title {
    font-size: 18px;
    color: #242424;
  }

  .txt-common-txt {
    font-size: 18px;
    color: #797979;
    flex: 1;
  }
}

.projectIntroduction-main {
  width: 774px;
  height: 145px;
  overflow: hidden;
  position: relative;
  display: flex;
  margin-top: 20px;
}

.projectIntroduction-item {
  flex: 0 0 auto;
  margin-right: 20px;
}

.list-image {
  width: 244px;
  height: 145px;
  object-fit: cover;
}
</style>
